<template>
    <div style="padding-top: 80px">
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Quejas por Contestar</p>

            </v-card-title>
            <v-form>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12">
                            <DataTable :url="urlBusqueda"
                                       :columns="columnsBusqueda"
                                       :formatterActions="formatterActions"
                                       :params="datos"
                                       @apiDT="apiDT = $event"
                                       :order="[[ 0, 'desc' ]]"></DataTable>



                        </v-col>
                    </v-row>


                </v-card-text>


            </v-form>
        </v-card>



    </div>
</template>




<script>
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import Quejas from "@/services/Quejas/Quejas.service.js";
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
    import Menu from '@/components/pages/Quejas/Menu/Menu.vue';
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
        },
        data() {
            return {
                datos: {
                },
                urlBusqueda: "Quejas/obtenerQuejaPendientes",
                columnsBusqueda: [
                    { name: 'idQueja', data: 'idQueja', title: "No. Queja" },
                    { name: 'reporte', data: 'reporte', title: "Reporte" },
                    { name: 'quetipoqueja', data: 'quetipoqueja', title: "Tipo" },
                    { name: 'quenombre', data: 'quenombre', title: "Quejoso" },
                    { name: 'dpnombre', data: 'dpnombre', title: "Departamento" },
                    { name: 'quedescripcion', data: 'quedescripcion', title: "Detalle" },
                    { name: 'clnombrecorto', data: 'clnombrecorto', title: "Aseguradora" },
                    { name: 'uslogin', data: 'uslogin', title: "Registró" },
                    { name: 'quefecha', data: 'quefecha', title: "Fecha" },
                    { name: 'semaforo', data: 'semaforo', title: "Semáforo", formatter: [this, "formatearEstatus"], orderable: false },
                    { name: "det", data: "det", title: "Detalle", formatter: [this, "formatearDetalle"], orderable: false },
                ],
                formatterActions: [
                    { click: [this, "irDetalleQueja"] },

                ],
            }
        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
        },
        methods: {
            formatearEstatus(x) {
                return `<div class="v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small" title="Hace ` + x.hora + ` horas." style="height: 30px; width: 30px; background-color:` + x.color + `"><span class="v-btn__content"></span></div>`;

            },
            formatearDetalle(x) {
                return `<button type="button" data-action="0" data-params="${x}" class="dt-formatterAction v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small blue" title="Ir a Detalle" style="height: 30px; width: 30px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-eye theme--dark" style="font-size: 20px;"></i></span></button>`;

            },
            async irDetalleQueja(params, item, fila) {

                var queja = {
                    idQueja: item.idQueja,
                };

                await MetodosGenerales.guardarEnSesionInfoReporte(queja, 'quejas');

                this.$router.push({ name: `DetalleQueja` }).catch(error => error);


            },
            async BuscarReporte() {

                let reporte = {
                    nrreporte: this.nrreporte,
                    svindice: this.svindice,
                    aiclave: this.aiclave,
                    svfhconclusion: this.svfhconclusion
                };

                var ver = 0;
                let formData = new FormData();
                formData.append("nrreporte", this.nrreporte);
                formData.append("svindice", this.svindice);
                await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                    ver = data;
                });



                let routerName = MetodosGenerales.obtenerRouterName(this.aiclave.toString());


                if (ver == 0) {
                    this.$router.push({ name: `${"DatosIncompletos"}` });
                }
                else {
                    await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                    let url = this.$router.resolve({ name: `${routerName}` });

                    window.open(url.href, '_blank');


                }
            },


        },
        async mounted() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "208"//modulo de quejas
            ).then((response) => {
                if (response.data.length == 0) {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                    return
                }
            });
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "213"//modulo de quejas Pendientes
            ).then((response) => {
                if (response.data.length == 0) {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                    return
                }
            });

            

        }
    }

</script>
<style>
    .disabled-btn {
        pointer-events: none;
    }
</style>